import { expenseUntraceable } from '@/function/expense/expense.state';
import type { TypeExpense } from '@/types/expense/types.expense';
import type { TypeExpenseQuery } from '@/types/expense/types.expense.query';

export function expenseQueryMatch(expense: TypeExpense, query: TypeExpenseQuery): boolean | null {
    if ((query.stage === 'planned') !== (expense.stage === 'planned')) return false;
    const unpaid = !expense.paidDate;
    const overdue = unpaid && Boolean(expense.dueDate) && expense.dueDate < query.today;
    if (query.state === 'paid' && unpaid) return false;
    if (query.state === 'due' && (!unpaid || overdue)) return false;
    if (query.state === 'overdue' && !overdue) return false;
    if (query.category && expense.category !== query.category) return false;
    if (query.rebill === 'none' && expense.rebillMode !== 'none') return false;
    if (query.rebill === 'to-rebill' && (expense.rebillMode === 'none' || Boolean(expense.invoiceId))) return false;
    if (query.rebill === 'rebilled' && !expense.invoiceId) return false;
    if (query.customerId && expense.customerId !== query.customerId) return false;
    if (query.facet === 'recurring' && expense.recurrence === 'none') return false;
    if (query.facet === 'foreign' && expense.supplierCountry === 'IT') return false;
    if (query.facet === 'project' && !expense.projectId) return false;
    if (query.facet === 'cash' && !expenseUntraceable(expense)) return false;
    if (query.from && expense.documentDate < query.from) return false;
    if (query.to && expense.documentDate > query.to) return false;
    return query.search ? null : true;
}

export default expenseQueryMatch;
